import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, API } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("Session exchange failed");
        const userData = await res.json();
        setUser(userData);

        // Route based on role
        if (userData.role === "admin") navigate("/admin", { replace: true });
        else if (userData.role === "council_member") navigate("/council", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (err) {
        toast.error("Authentication failed. Please try again.");
        navigate("/login", { replace: true });
      }
    };

    exchangeSession();
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#0F172A] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#52525B] font-medium">Completing sign-in...</p>
      </div>
    </div>
  );
}
